import { render } from "./tool-icon.svg?vue&type=template&id=1cf26a1a"
import script from "./tool-icon.svg?vue&type=script&lang=js"
export * from "./tool-icon.svg?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1567/src/s3/00/src/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__